/**
 * Created by miguel on 23/2/17.
 */

class EventListViewController extends BaseTableViewController
{
    // kind: only the events of that kind (Shows, Planned events sections); null = every event
    static newInstance(kind:VenueEventKind = null, titleKey:string = "EVENTS") : EventListViewController {
        let vc = new EventListViewController("event-list-view");
        vc.initWithResource("layout/event/EventListView.html");
        vc.kind = kind;
        vc.titleKey = titleKey;
        return vc;
    }

    kind:VenueEventKind = null;
    titleKey:string = "EVENTS";

    private addButton:MUIButton = null;
    private titleLabel:MUILabel = null;
    private _event:VenueEvent = null;
        
    viewDidLoad(){
        super.viewDidLoad();

        this.titleLabel = MUIOutlet(this, 'title-lbl', 'MUILabel');
        if (this.titleLabel != null) this.titleLabel.text = MIOLocalizeString(this.titleKey, this.titleKey);

        this.addButton = MUIOutlet(this, 'add_btn','MUIButton');
        this.addButton.setAction(this, function(this:EventListViewController){
            this.addEvent();
        });

        this.searchTextField = MUIOutlet(this, 'search_bar','MUITextField');
        this.setupSearchTextField();

        this.tableView = MUIOutlet(this, 'tableview', 'UITableView');
        this.tableView.dataSource = this;
        this.tableView.delegate = this;             
    }

    titleForHeaderInSection(tableView:UITableView, section:number){
        let ip = MIOIndexPath.indexForRowInSection(0, section);
        let event = this.fetchedResultsController.objectAtIndexPath(ip);

        let ad:AppDelegate = MUIWebApplication.sharedInstance().delegate;
        return ad.dateFormatter.stringFromDate(event.date);
    }
    
    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let cell = tableView.dequeueReusableCellWithIdentifier('EventCell') as EventCell;
    
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as VenueEvent;
        cell.item = item;
    
        cell.selected = (this.selectedItem?.identifier == item.identifier);

        return cell;
    }
        
    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        this.selectedItem = this.fetchedResultsController.objectAtIndexPath(indexPath) as VenueEvent;
        this.showSelectedItem();
    }
        
    private showSelectedItem(){        
        let vc  = EventDetailViewController.newInstance();   
        vc.event = this.selectedItem;
        let nc = new MUINavigationController();
        nc.initWithRootViewController(vc);

        this.splitViewController.showDetailViewController(nc);
    }

    public showNoItem(){
        let vc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("Events", NoItemSelectedViewControllerType.Events)        
        this.splitViewController.showDetailViewController(vc);
    }
        
    get fetchedResultsController(){
        if (this._fetchedResultsController != null) return this._fetchedResultsController;
    
        let ad = MUIWebApplication.sharedInstance().delegate;

        let sortDescriptors = [ MIOSortDescriptor.sortDescriptorWithKey("beginDateTime", true),
                                MIOSortDescriptor.sortDescriptorWithKey("name", true)];
    
        let predicates = [];
        if (this.searchString != null && this.searchString.length > 0) predicates.push('name CONTAINS "' + this.searchString + '"');
        if (this.kind != null) predicates.push("kind == " + this.kind);

        let fetchRequest = DBHelper.listFetchRequestWithEntityName("VenueEvent", sortDescriptors, predicates.length > 0 ? predicates.join(" AND ") : null);
        // fetchRequest.relationshipKeyPathsForPrefetching = [];
        
        let fetchedResultsController = new MIOFetchedResultsController();                
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, "beginDate");
        fetchedResultsController.delegate = this;
    
        fetchedResultsController.performFetch();
    
        this._fetchedResultsController = fetchedResultsController;
    
        return this._fetchedResultsController;
    }
    
    private addEvent(){
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("NEW_EVENT", "NEW EVENT"), MIOLocalizeString("CHOOSE_A_NAME", "CHOOSE A NAME"), MUIAlertViewStyle.Default);
        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
            textField.setPlaceholderText(MIOLocalizeString("NAME","NAME"));
        });

        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
            textField.setPlaceholderText(MIOLocalizeString("NUMBER OF PEOPLE","NUMBER OF PEOPLE"));
        });

        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
            textField.setPlaceholderText(MIOLocalizeString("EVENT DATE","EVENT DATE"));
            textField.text = MUIWebApplication.sharedInstance().delegate.dateFormatter.stringFromDate(MIODateNow());
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('OK','OK'), MUIAlertActionStyle.Default, this, function(this:EventListViewController){
            let name =  avc.textFields[0].text.trim();
            let pax = avc.textFields[1].text.trim();
            let date = avc.textFields[2].text.trim();
            
            this.createEvent(name, pax, date);
        }));
        
        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CANCEL','CANCEL'), MUIAlertActionStyle.Cancel, null, null));
        
        this.presentViewController(avc, true);        
    }

    private createEvent(name:string, pax:string, date:string){

        let ad = MUIWebApplication.sharedInstance().delegate;

        // Each field gets its own message: the old check reported "must have a name" for any
        // empty field, which looked like the name was not being read.
        if (name.length == 0) {
            AppHelper.showErrorMessage(this, MIOLocalizeString('ERROR', "ERROR"), MIOLocalizeString("MUST_HAVE_A_NAME", "MUST HAVE A NAME"));
            return;
        }

        // Number of people is optional (0 = not set)
        let paxValue = pax.length > 0 ? ad.integerFormatter.numberFromString(pax) : 0;
        if (paxValue == null || paxValue < 0) {
            AppHelper.showErrorMessage(this, MIOLocalizeString('ERROR', "ERROR"), MIOLocalizeString("INVALID_NUMBER_OF_PEOPLE", "INVALID NUMBER OF PEOPLE"));
            return;
        }

        let eventDate = date.length > 0 ? ad.dateFormatter.dateFromString(date) : null;
        if (eventDate == null) {
            AppHelper.showErrorMessage(this, MIOLocalizeString('ERROR', "ERROR"), MIOLocalizeString("INVALID_EVENT_DATE", "INVALID EVENT DATE"));
            return;
        }

        this._event = MIOEntityDescription.insertNewObjectForEntityForName("VenueEvent", ad.managedObjectContext) as VenueEvent;

        this._event.identifier = MIOUUID.UUID().UUIDString;
        this._event.name = name;
        this._event.pax = paxValue;
        this._event.isActive = true;
        this._event.kind = this.kind ?? VenueEventKind.Generic;
        //this._event.closePlace = false;
        this._event.beginDateTime = eventDate;
        let endDate = new Date(eventDate);
        endDate.setDate(endDate.getDate() + 1);
        this._event.endDateTime = endDate;

        ad.managedObjectContext.save();
        this.showSelectedItem();
    }


}